// Copyright 2020 Sorama B.V.

import { bindable, bindingMode, customElement, observable } from "aurelia-framework";
import { ShellViewManager } from "modules/shell/App/ShellViewManager";
import { IUserSettingsService } from "services/UserManagement/IUserSettingsService";

@customElement("tip")
export class Tip {
    private static tipGroupKey = "Tip";
    private static tipPropertyKey = "notShowNextTime";

    @observable
    private isChecked = false;

    /**
     * An unique id to store the state of this control in cache. Only required when operating mode is not "always"
     */
    @bindable({ defaultBindingMode: bindingMode.oneWay })
    public tipUniqueId?: string;

    @bindable({ defaultBindingMode: bindingMode.oneWay })
    private tipTitle?: string;

    @bindable({ defaultBindingMode: bindingMode.oneWay })
    private tipContent?: string;

    @bindable({ defaultBindingMode: bindingMode.oneWay })
    private tipLink?: string;

    @bindable({ defaultBindingMode: bindingMode.oneWay })
    private tipImage?: string;

    public tipClosed = false;

    @bindable({ defaultBindingMode: bindingMode.oneTime })
    public showMode: "always" | "once" | "user" = "always";

    constructor(
        private readonly userSettingsService: IUserSettingsService,
        private readonly shellviewManager: ShellViewManager
    ) {}

    public bind() {
        if (this.showMode !== "always") {
            let promise = Promise.resolve();

            promise = this.userSettingsService
                .hasKey(Tip.tipGroupKey + this.tipUniqueId, Tip.tipPropertyKey)
                .then((isAvailable) => {
                    if (isAvailable) {
                        return this.userSettingsService
                            .get(Tip.tipGroupKey + this.tipUniqueId, Tip.tipPropertyKey)
                            .then((x) => {
                                this.tipClosed = x == "true";
                            });
                    }
                });

            if (this.showMode === "once") {
                promise.then(() => this.setNotShowingNextTime(true));
            }
        }
    }

    public openTopic() {
        if (this.tipLink) {
            this.shellviewManager.openRightSideBarHelp(this.tipLink);
        }
    }

    public setNotShowingNextTime(notShowNextTime: boolean): void {
        if (this.showMode !== "always") {
            this.userSettingsService.set(
                Tip.tipGroupKey + this.tipUniqueId,
                Tip.tipPropertyKey,
                notShowNextTime ? "true" : "false"
            );
        }
    }

    public isCheckedChanged(): void {
        this.setNotShowingNextTime(this.isChecked);
    }
}
